<template>
  <v-container>
    <v-row>
      <v-col>
        <div v-if="!isSummaryView">
          <p class="title font-weight-light" v-html="title" />
          <v-textarea
            v-model="verbatimText"
            :rules="[
              v =>
                !isRequired ||
                currentStep !== this.$props.pageNr ||
                (!!v && v.length > 0) ||
                'Please share your comments.'
            ]"
            outlined
          />
        </div>

        <div class="mt-10" v-else>
          <p class="title font-weight-black" v-html="title" />
          <p>{{ verbatimText }}</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Improvement',

  props: ['verbatim', 'field', 'isRequired', 'pageNr', 'isSummaryView'],

  data() {
    return {
      verbatimField: `${this.field}Verbatim`,
    };
  },

  computed: {
    ...mapGetters(['currentStep', 'isSelfSurvey']),
    params() {
      return this.$store.state.params;
    },
    title() {
      return this.verbatim.title(this.isSelfSurvey, this.params);
    },
    verbatimText: {
      get() {
        return this.$store.state.response[this.verbatimField];
      },
      set(newValue) {
        this.$store.commit('storeResponse', {
          k: this.verbatimField,
          v: newValue,
        });
      },
    },
  },
};
</script>
